import React from 'react';

const NewCommentBadge = ({ isNewComment, text = 'N', ...otherStyles }) => {
  if (!isNewComment) return null;

  const defaultStyle = {
    backgroundColor: '#db470d',
    color: '#fff',
    padding: '2px 4px',
    borderRadius: '3px',
    marginLeft: '4px',
    fontSize: '10px',
    fontWeight: 'bold',
  };

  return (
    <span
      style={{
        ...defaultStyle,
        ...otherStyles,
      }}
    >
      {text}
    </span>
  );
};

export default NewCommentBadge;
